import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { MediaQuery } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Video = styled.div`
  margin: ${({ isSquareVideo }) =>
    isSquareVideo ? '0 auto 100px auto' : '30px auto 0 auto'};
  max-width: ${({ isSquareVideo }) => (isSquareVideo ? '1000px' : 'initial')};

  ${MediaQuery.XL_AND_DOWN} {
    padding: ${({ isSquareVideo }) => (isSquareVideo ? '0 45px;' : 'none')};
  }

  ${MediaQuery.M_AND_DOWN} {
    margin: ${({ isSquareVideo }) =>
      isSquareVideo ? '0 auto 60px auto' : '0 auto 100px auto'};
  }

  ${MediaQuery.M_AND_DOWN} {
    padding: 0 15px;
  }
`;

export const Title = styled.h3`
  ${Typography.XXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  padding-bottom: 30px;
`;

export const VideoWrapper = styled.div`
  text-align: center;
  border-radius: ${({ isSquareVideo }) => (isSquareVideo ? '45px' : 'initial')};
  overflow: ${({ isSquareVideo }) => (isSquareVideo ? 'hidden' : 'initial')};

  ${MediaQuery.L_AND_DOWN} {
    border-radius: ${({ isSquareVideo }) =>
      isSquareVideo ? '25px' : 'initial'};
  }

  ${MediaQuery.M_AND_DOWN} {
    border-radius: ${({ isSquareVideo }) =>
      isSquareVideo ? '15px' : 'initial'};
  }
`;

export const Caption = styled.p`
  ${Typography.M};
  padding: 10px 20px 0 20px;
`;
